export default __webpack_public_path__ + "static/media/flag-he.b6f684e8.svg";